export interface TimestampedValue {
  t: number;
  v: number;
}

const RATE_WINDOW_MS = 30_000;

/** Messages or requests per second over ~30s window. */
export function ratePerSecond(history: TimestampedValue[]): number | null {
  if (history.length < 2) {
    return null;
  }
  const latest = history[history.length - 1];
  const targetT = latest.t - RATE_WINDOW_MS;
  let baseline = history[0];
  for (const point of history) {
    if (point.t <= targetT) {
      baseline = point;
    } else {
      break;
    }
  }
  const elapsedMs = latest.t - baseline.t;
  if (elapsedMs <= 0) {
    return null;
  }
  const delta = latest.v - baseline.v;
  if (delta < 0) {
    return null;
  }
  return delta / (elapsedMs / 1000);
}

/** Average increment per count sample in window (e.g. seconds per POST). */
export function avgDeltaPerCount(
  countHistory: TimestampedValue[],
  sumHistory: TimestampedValue[]
): number | null {
  if (countHistory.length < 2 || sumHistory.length < 2) {
    return null;
  }
  const countLatest = countHistory[countHistory.length - 1];
  const sumLatest = sumHistory[sumHistory.length - 1];
  const targetT = countLatest.t - RATE_WINDOW_MS;

  let countBase = countHistory[0];
  let sumBase = sumHistory[0];
  for (let i = 0; i < countHistory.length; i++) {
    if (countHistory[i].t <= targetT) {
      countBase = countHistory[i];
      sumBase = sumHistory[i];
    }
  }

  const dCount = countLatest.v - countBase.v;
  const dSum = sumLatest.v - sumBase.v;
  if (dCount <= 0 || dSum < 0) {
    return null;
  }
  return dSum / dCount;
}

export function formatRate(value: number | null, digits = 1): string {
  if (value === null) {
    return '—';
  }
  if (value < 0.05) {
    return '0';
  }
  return value.toFixed(digits);
}

export function formatMsFromSeconds(seconds: number | null): string {
  if (seconds === null) {
    return '—';
  }
  return `${(seconds * 1000).toFixed(0)} ms`;
}

export function formatLocalTime(date: Date): string {
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  });
}
